import React, { useState, useEffect } from 'react';
import { Button, Typography, Box, Paper, Divider, Grid } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import axios from 'axios';

const SchoolPage = () => {
  const [syllabusData, setSyllabusData] = useState([]);
  const [timetableData, setTimetableData] = useState([]);
  const [rulesVisible, setRulesVisible] = useState(true);
  const [stagesVisible, setStagesVisible] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [syllabusRes, timetableRes] = await Promise.all([
          axios.get('https://backend-school-914b.onrender.com/syllabus'),
          axios.get('https://backend-school-914b.onrender.com/timetable'),
        ]);
        setSyllabusData(syllabusRes.data);
        setTimetableData(timetableRes.data);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    fetchData();
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f9f9f9' }}>
      <Header />

      <Box sx={{ flex: 1, padding: '40px 20px' }}>


        <Box sx={{ display: 'flex', justifyContent: 'center', gap: '30px', flexWrap: 'wrap', marginBottom: '30px' }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: '#4caf50', color: '#fff', padding: '10px 20px', borderRadius: '10px', fontSize: '16px' }}
            onClick={() => {
              setStagesVisible(true);
              setRulesVisible(false);
            }}
          >
            Stages
          </Button>

          <Button
            variant="contained"
            sx={{ backgroundColor: '#2196f3', color: '#fff', padding: '10px 20px', borderRadius: '10px', fontSize: '16px' }}
            onClick={() => {
              setStagesVisible(false);
              setRulesVisible(false);
            }}
          >
            Syllabus
          </Button>

          <Button
            variant="contained"
            sx={{ backgroundColor: '#ff5722', color: '#fff', padding: '10px 20px', borderRadius: '10px', fontSize: '16px' }}
            onClick={() => {
              setRulesVisible(true);
              setStagesVisible(false);
            }}
          >
            Rules and Regulations
          </Button>
        </Box>

        {stagesVisible && (
          <Paper sx={{ marginTop: '20px', padding: '30px', backgroundColor: '#fefefe', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '20px', color: '#444' }}>
              Stages
            </Typography>
            <Typography sx={{ marginBottom: '10px', lineHeight: '1.8', color: '#666' }}>
              <b>Nursery:</b> Ages 3-5 years. This stage focuses on developing basic social, emotional, and cognitive skills through playful learning.
            </Typography>
            <Typography sx={{ marginBottom: '10px', lineHeight: '1.8', color: '#666' }}>
              <b>Primary Classes (1 to 5):</b> Ages 6-11 years. A curriculum that goes beyond books to nurture holistic development. We focus on fostering creativity, critical thinking, and foundational academic skills.
            </Typography>
            <Typography sx={{ lineHeight: '1.8', color: '#666' }}>
              <b>Beyond Books:</b> Emphasis is placed on practical learning, interactive activities, and co-curricular engagements like art, music, and physical education.
            </Typography>
          </Paper>
        )}

        {!stagesVisible && !rulesVisible && (
          <Paper sx={{ marginTop: '20px', padding: '30px', backgroundColor: '#fefefe', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '20px', color: '#444' }}>
              Syllabus
            </Typography>
            <Grid container spacing={3}>
              {syllabusData.map((item) => (
                <Grid item xs={12} sm={6} md={4} key={item._id}>
                  <Paper
                    sx={{
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#f9f9f9',
                      borderRadius: '10px',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '10px', color: '#333' }}>
                      {item.class}
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: '#4caf50', color: '#fff', padding: '5px 15px', fontSize: '14px', borderRadius: '8px' }}
                      onClick={() => {
                        window.location.href = item.downloadLink;
                      }}
                    >
                      Download Syllabus
                    </Button>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Paper>
        )}

        {rulesVisible && (
          <Paper sx={{ marginTop: '20px', padding: '30px', backgroundColor: '#fefefe', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '20px', textAlign: 'center', color: '#444' }}>
              General Rules
            </Typography>
            <Divider sx={{ marginBottom: '20px' }} />
        <ul>
  <li>
   <b> It is compulsory for students to:</b>
    <ul>
      <li>Carry their I-Card and diary every day.</li>
      <li>Ensure all communication between parents/guardians and teachers is made through the diary.</li>
    </ul>
  </li>

  <li>
  <b> School uniform and personal grooming:</b>
    <ul>
      <li>Pupils must wear the prescribed uniform for the season on class days and school functions.</li>
      <li>Pupils should come to school clean and tidy.</li>
      <li>Pupils not dressed correctly or with improper appearance will be sent home as personal training.</li>
      <li>Persistent irregularity in uniform or punctuality may lead to withdrawal of the student.</li>
    </ul>
  </li>
  <li>
  <b> Attendance and punctuality:</b>
    <ul>
      <li>Latecomers or those absent on the previous day must bring a letter of explanation signed by parents and countersigned by the Principal.</li>
      <li>Leaving school premises during regular hours is strictly forbidden unless permitted by the Principal.</li>
    </ul>
  </li>
  <li>
  <b>  Disciplinary actions may be taken for:</b>
    <ul>
      <li>Irregular attendance, habitual idleness, or neglect of homework.</li>
      <li>Disobedience, disrespect towards school staff, or bad moral influence.</li>
    </ul>
  </li>
  <li>
  <b> Student conduct:</b>
    <ul>
      <li>Pupils must behave responsibly on their way to and from school.</li>
      <li>Bringing objectionable literature, mobile phones, or electronic gadgets to school is strictly forbidden.</li>
      <li>During a teacher’s absence, pupils must follow the instructions of the appointed monitor.</li>
    </ul>
  </li>
  <li>
  <b> School property:</b>
    <ul>
      <li>Any damage to school premises, furniture, or fixtures will be charged to the responsible student.</li>
    </ul>
  </li>
  <li>
  <b> Parental cooperation:</b>
    <ul>
      <li>Parents should ensure regularity, discipline, and interest in their child’s progress.</li>
      <li>Encourage participation in co-curricular and extra-curricular activities.</li>
    </ul>
  </li>
  <li>
  <b> Health and safety:</b>
    <ul>
      <li>A fitness certificate is required for a student recovering from or exposed to infectious diseases.</li>
    </ul>
  </li>
  <li>
  <b>  Private tuition:</b>
    <ul>
      <li>Private tutors should only be employed in exceptional cases with prior permission from the Principal.</li>
      <li>Teachers are not allowed to tutor students from their own classes.</li>
    </ul>
  </li>
  <li>
  <b>  School diary and updates:</b>
    <ul>
      <li>A school diary is published annually and contains updated rules and regulations.</li>
      <li>Each student must possess a copy of the diary.</li>
    </ul>
  </li>
  <li>
  <b>Transfer certificates:</b>
    <ul>
      <li>Duplicate copies of Transfer Certificates are issued only in special cases with proof verification and permission from the Inspector of Anglo-Indian Schools, U.P., on payment of Rs.500/-.</li>
    </ul>
  </li>
  <li>
  <b>  Co-curricular and extra-curricular activities:</b>
    <ul>
      <li>Participation in these activities is compulsory when required by the school authorities.</li>
    </ul>
  </li>
  <li>
  <b> Visitors:</b>
    <ul>
      <li>Parents, relatives, guardians, or friends must seek prior permission from the Principal to meet teachers, students, or enter classrooms.</li>
    </ul>
  </li>
</ul>
          </Paper>
        )}
      </Box>

      <Footer />
    </Box>
  );
};

export default SchoolPage;
